export const buildEndpointMap = (root: string, storyblokRoot: string) => ({
  rootDomain: root,
  endpoint: {
    adhocAnnouncement: `${root}/news/adhoc`,
    adhocAnnouncementYears: `${root}/news/adhoc/years`,
    diagnostics: `${root}/pipeline-diagnostics`,
    events: `${root}/events`,
    eventYears: `${root}/events/years`,
    locations: `${root}/locations`,
    locationsByContinent: `${root}/locations/adresses`,
    news: `${root}/news`,
    newsYears: `${root}/news/years`,
    patient: `${root}/patient-organisations`,
    patientCountries: `${root}/patient-organisations/countries`,
    pipeline: `${root}/pipeline`,
    pipelineChanges: `${root}/pipeline-changes`,
    pipelineDiagnostics: `${root}/pipeline-diagnostics`,
    stockInformation: `${root}/stock-information`,
    pubMed: `${root}/pubmed`,
    pubMedCategories: `${root}/pubmed/categories`,
    safetyOfficers: `${root}/local-safety-officers`,
    safetyReporting: `${root}/local-safety-reportings`,
    upcomingEvents: `${root}/events/upcoming`,
    datasourceEntries: `${storyblokRoot}/datasource_entries`,
    stories: `${storyblokRoot}/stories`,
  },
});
